import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EntityService } from '@services/entity/entity.service';
import { Observable } from 'rxjs';
import { Blackbox } from '@models/blackbox';
import { BlackboxSetup } from '@dto/blackboxSetup';

@Injectable({
  providedIn: 'root'
})
export class BlackboxService extends EntityService {

  public entityRoute = "blackboxes";

  constructor(
    http: HttpClient,
    @Inject('BASE_URL') baseUrl: string
  ) {
    super(http, baseUrl);
  }

  get(blackboxId: number): Observable<Blackbox> {
    return this.http.get<Blackbox>(`${this.baseUrl}api/blackbox/${blackboxId}`);
  }

  getAll(): Observable<Blackbox[]> {
    return this.http.get<Blackbox[]>(`${this.baseUrl}api/blackbox/all`);
  }

  getAllByCurrentCustomer(): Observable<Blackbox[]> {
    return this.http.get<Blackbox[]>(`${this.baseUrl}api/blackbox/getAllByCurrentCustomer`);
  }

  getByCustomerId(customerId: number): Observable<Blackbox[]> {
    return this.http.get<Blackbox[]>(`${this.baseUrl}api/blackbox/customer/${customerId}`);
  }

  patch(blackbox: Blackbox): Observable<Blackbox> {
    return this.http.patch<Blackbox>(`${this.baseUrl}api/blackbox/patch/${blackbox.id}`, blackbox);
  }

  setup(setup: BlackboxSetup): Observable<BlackboxSetup> {
    return this.http.post<BlackboxSetup>(`${this.baseUrl}api/blackboxsetup`, setup);
  }

  getCount(): Observable<number> {
    return this.http.get<number>(`${this.baseUrl}api/blackbox/count`);
  }

  search(searchTerm: string): Observable<Blackbox[]> {
    return this.http.get<Blackbox[]>(`${this.baseUrl}api/blackbox/search/${searchTerm}`);
  }

  downloadCsv(blackboxId: number, year: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}api/blackbox/${blackboxId}/download/csv/${year}`, { responseType: 'blob' as 'json'});
  }

  downloadXlsx(blackboxId: number, year: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}api/blackbox/${blackboxId}/download/xlsx/${year}`, { responseType: 'blob' as 'json'});
  }
}
